import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Pulls the active master-data items for a kind (subject, grade, board,
 * country). Falls back to a hardcoded list if the public endpoint is
 * unreachable, so the form is never blank.
 *
 * Usage:
 *   const { items, loading } = useMasterList("subject");
 *   const subjects = items.map((i) => i.value);
 */
export function useMasterList(kind, { parentId = null, fallback = [] } = {}) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        async function run() {
            setLoading(true);
            try {
                const qs = new URLSearchParams({ limit: "500" });
                if (parentId) qs.set("parent_id", parentId);
                const r = await api.get(`/master/${kind}?${qs.toString()}`);
                if (!cancelled) {
                    setItems(r.data.items || []);
                    setError(null);
                }
            } catch (e) {
                if (!cancelled) {
                    setError(e);
                    setItems(fallback.map((v, i) => ({ id: `fb-${i}`, value: v, kind })));
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }
        run();
        return () => { cancelled = true; };
    }, [kind, parentId]);  // eslint-disable-line react-hooks/exhaustive-deps

    return { items, loading, error };
}
